.moreRow {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

/* An outlined pill in the brand brown, as secondary as the cards allow. */
.moreButton {
  min-height: 48px;
  padding: 0 28px;
  border: 1px solid var(--primary);
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--primary);
  font: 500 15px var(--font-body);
  cursor: pointer;
}

.moreButton:hover {
  background: var(--primary);
  color: #ffffff;
}
